import React from 'react'
import { Link } from 'react-router'
import { config } from 'config'

/**
 *  Renders required JSON-LD markup for Product
 *  This should meet minimum requirements to be emphasized in Google search results:
 *
 *  	"Add markup to your product pages so Google can provide detailed product
 * 			information in rich Search results — including Image Search. Users can
 * 			see price, availability, and review ratings right on Search results."
 *
 *  See [https://developers.google.com/search/docs/data-types/products]
 */
class Product extends React.Component {
	render() {

		const {
			name,
			imagePath,
			description,
			url
		} = this.props

		const {
			rootUrl,
			organizationName
		} = config

		const schemaJson = {
		  "@context": "http://schema.org/",
		  "@type": "Product",
		  "name": name,
		  "image": `${rootUrl}${imagePath}`,
		  "description": description,
		  "mpn": name,
		  "brand": {
		    "@type": "Organization",
		    "name": organizationName,
				"url": rootUrl,
				"contactPoint": {
					"@type": "ContactPoint",
					"email": "pargo@acousticcleaning.com",
					"telephone": "+1 (256) 820-8247",
					"faxNumber": "+1 (256) 820-6570",
					"name": "Paul Argo",
					"contactType": "customer service"
				}
		  },
			"url": `${rootUrl}${url}`
		}

		return <script type="application/ld+json" dangerouslySetInnerHTML={{ __html: JSON.stringify(schemaJson, null, '  ') }} />
	}
}

Product.propTypes = {
	name: React.PropTypes.string.isRequired,
	description: React.PropTypes.string.isRequired,
	imagePath: React.PropTypes.string.isRequired,
	url: React.PropTypes.string.isRequired
}

export default Product



// WEBPACK FOOTER //
// ../components/SchemaJson/Product.js